<template>
  <div class="flex flex-col m-1"
    :class="{
      'bg-gray-200': listIndex % 2 == 0,
      'bg-gray-100': listIndex % 2 == 1,
    }">
    <div class="m-2 uppercase rounded-sm text-sm font-bold bg-gray-800 text-center text-red-400"
      v-if="!portalUserExists">
      Portal User Missing
    </div>
    <div class="grid grid-cols-12">
      <div class="p-2 col-span-2">
        <span class="w-full truncate text-sm">
          {{ auth0User.name }}
        </span>
      </div>
      <div class="p-2 col-span-2">
        <div class="w-full truncate text-sm">
          {{ auth0User.email }}
        </div>
      </div>
      <div class="p-2 col-span-2">
        <div class="w-full truncate text-sm">
          {{ auth0User.user_id }}
        </div>
      </div>
      <div class="col-span-2 flex flex-col w-full">
        <Group class="col-span-2"
          :enableAddGroup="portalUserExists"
          :userGroupOptions="userGroupOptions"
          :defaultValue="defaultGroups"
          v-model="formValues.groups"
        />
      </div>
      <div class="col-span-3 flex flex-col w-full">
        <ConfigSection
          :showHeader="false"
          :defaultValue="defaultConfig"
          v-model="formValues.config"
        />
      </div>
      <div class="flex flex-col col-span-1 gap-1">
        <Button class="rounded-sm uppercase text-sm font-bold bg-sky-600 hover:bg-sky-200 text-white text-center"
          v-if="showPortalUserError && !portalUserExists"
          @click="onCreatePortalUser">
          Create<br>Portal User
        </Button>
        <Button
          color="gray"
          size="sm"
          @click="onEditEntryButtonPress">
          Edit Entry
        </Button>
        <Button
          color="gray"
          size="sm"
          @click="onDeleteEntryButtonPress">
          Delete Entry
        </Button>
      </div>
      <div class="flex flex-row col-span-10 items-center"
        v-if="showCommandExtension">
        <textarea class="m-2 p-2 w-[90%] h-14 text-sm"
          v-model="editCommand">
        </textarea>
        <Button class="w-32 m-2"
          color="blue"
          size="sm"
          @click="addUserQuery">
          Add to Query
        </Button>
        <XButton class="bg-orange-200 p-1 w-6 h-6 justify-center"
          @click="closeCommandExtension"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Group from './Group.vue'
import ConfigSection from './ConfigSection.vue'

import XButton from '../XButton.vue'
import Button from '../Button.vue'

import userManagementService from '../../services/pages/userManagement.js'

import { isEmpty } from 'lodash'

export default {
  props: {
    auth0User: Object,
    portalUser: Object,
    userGroupOptions: Array,
    listIndex: Number,
    defaultValue: Object,
    value: undefined,
    showPortalUserError: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    ConfigSection,
    Group,
    XButton,
    Button,
  },
  data() {
    return {
      formValues: {
        groups: [],
        config: {},
        createPortalUser: false,
      },

      showCommandExtension: false,
      updateCommandType: undefined,
      editCommand: undefined,

      pendingKey: false,
      pendingValue: false,
    }
  },
  methods: {
    onEditEntryButtonPress() {
      this.showCommandExtension = true
      this.updateCommandType = 'edit'
      this.createEditEntry()
    },
    onDeleteEntryButtonPress() {
      this.showCommandExtension = true
      this.updateCommandType = 'delete'
      this.createDeleteEntry()
    },
    onCreatePortalUser() {
      this.formValues.createPortalUser = !this.formValues.createPortalUser
      this.onEditEntryButtonPress()
    },
    createEditEntry() {
      this.editCommand = userManagementService.createEditUserQuery(
        this.auth0User.user_id,
        this.auth0User.name,
        this.auth0User.email,
        this.formValues.groups,
        this.formValues.config.userConfig,
        this.formValues.config.appMetadata,
        this.formValues.createPortalUser,
      )
    },
    createDeleteEntry() {
      this.editCommand = userManagementService.createDeleteUserQuery(
        this.auth0User.user_id
      )
    },
    addUserQuery() {
      if (this.editCommand) {
        this.$emit('addUserQuery', this.editCommand)

        this.editCommand = undefined
        this.showCommandExtension = false
      }
    },
    closeCommandExtension() {
      this.showCommandExtension = false
    },
    clearCommand() {
      this.editCommand = undefined
      this.showCommandExtension = false
    }
  },
  mounted() {
    // do nothing
  },
  computed: {
    defaultConfig() {
      let retConfig = {}
      if (this.auth0User) {
        retConfig.appMetadata = this.auth0User['app_metadata']['kanan']
      }
      if (this.portalUser) {
        retConfig.userConfig = this.portalUser['user_config'].reduce(
          (accum, curr) => {
            accum[curr.key] = curr.config
            return accum
          },
          {}
        )

        if (isEmpty(retConfig.userConfig)) {
          retConfig.userConfig = undefined
        }
      }

      return retConfig
    },
    defaultGroups() {
      if (this.portalUser) {
        return this.portalUser.groups.map(group => group.name)
      }
      else {
        return undefined
      }
    },
    portalUserExists() {
      return this.portalUser != undefined
    },
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    'formValues.groups'() {
      if (this.showCommandExtension && this.updateCommandType === 'edit') {
        this.createEditEntry()
      }
    },
    'formValues.config': {
      handler() {
        if (this.showCommandExtension && this.updateCommandType === 'edit') {
          this.createEditEntry()
        }
      },
      deep: true,
    },
    portalUser() {
      this.clearCommand()
    },
    auth0User() {
      this.clearCommand()
    },
  }
}
</script>
